import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";
import { withRef } from "@udecode/cn";

export const ParagraphElement = withRef<typeof PlateElement>(
	({ children, ...props }: PlateElementProps, ref) => {
		return (
			<PlateElement
				ref={ref}
				style={{
					margin: 0,
					padding: "0.25rem 0",
				}}
				{...props}
			>
				{children}
			</PlateElement>
		);
	}
);

ParagraphElement.displayName = "ParagraphElement";
